import { useState, type ReactNode } from 'react'
import { Download, MonitorDown, PlusSquare, Share } from 'lucide-react'
import { useInstalleren } from '../lib/installeren'
import { Lade } from './Lade'

/*
 * De knop "Zet als app op je apparaat". Bij Chrome/Edge opent hij het
 * installatievenster van de browser zelf; bij Safari laat hij in twee
 * stappen zien hoe het via het menu gaat. Draait de site al als app, of kan
 * het niet (Firefox op de computer), dan is er geen knop.
 */
export function Installeren({ tekst = 'Zet als app op je apparaat', klasse = 'knop breed', naam = 'TW1 Club', donker = false }: {
  tekst?: string; klasse?: string; naam?: string; donker?: boolean
}) {
  const { soort, installeer } = useInstalleren()
  const [uitleg, zetUitleg] = useState(false)
  if (soort === 'geen') return null

  const klik = async () => {
    if (soort === 'voorstel') await installeer()
    else zetUitleg(true)
  }
  const stap = (n: number, inhoud: ReactNode) => (
    <li className="beloning-rij" style={{ alignItems: 'flex-start' }}>
      <span className="beloning-icoon" style={{ fontWeight: 800 }}>{n}</span>
      <span className="vul" style={{ paddingTop: 10 }}>{inhoud}</span>
    </li>
  )
  const deel = <Share size={18} style={{ display: 'inline', verticalAlign: '-3px' }} aria-label="Deel" />

  return (
    <>
      <button className={klasse} onClick={klik}>
        {soort === 'voorstel' ? <Download size={19} /> : soort === 'mac-safari' ? <MonitorDown size={19} /> : <PlusSquare size={19} />}
        {tekst}
      </button>
      <Lade titel={`${naam} als app`} open={uitleg} sluit={() => zetUitleg(false)} klasse={donker ? 'kiosk-lade' : undefined} kinderen={
        <div className="lijst" style={{ gap: 8 }}>
          <ol className="tijdlijn" style={{ margin: 0 }}>
            {soort === 'mac-safari' ? <>
              {stap(1, <>Kies in de menubalk <b>Archief</b></>)}
              {stap(2, <>Kies <b>Voeg toe aan Dock</b> en klik op <b>Voeg toe</b></>)}
            </> : <>
              {stap(1, <>Tik {soort === 'iphone' ? 'onderaan' : 'bovenaan'} op <b>Deel</b> {deel}</>)}
              {stap(2, <>Kies <b>Zet op beginscherm</b> (scroll zo nodig omlaag) en tik op <b>Voeg toe</b></>)}
            </>}
          </ol>
          <p className="stil klein">Daarna open je {naam} met één tik, zonder adresbalk, net als een gewone app.</p>
          <button className="knop geel breed" onClick={() => zetUitleg(false)}>Begrepen</button>
        </div>
      } />
    </>
  )
}
